var e=new Set;export{e as ViewsRegistry_default};